import { FC } from 'react';

import type { INewWalletQuery, INewWalletResponse, TWalletType } from '@entities/wallets';
import { useCreateWalletMutation } from '@entities/wallets';
import { ModalNewEntity } from '@features/modal-entity-new';
import { useModal } from '@shared/components/Modal';

import { NewWalletMID } from './NewWalletMID';

interface IProps {
  type: TWalletType;
  refetch: () => void;
}

export const NewWallet: FC<IProps> = ({ type, refetch }) => {
  const { openModal } = useModal();

  const newWalletKeys: (keyof INewWalletQuery)[] =
    type === 'settlement'
      ? ['merchant_id', 'mid_id', 'provider_id', 'type']
      : ([
          'type',
          'provider_id',
          'bank_id',
          'name',
          'wallet_address',
          'holder_name',
          'login_credentials_json',
          'bank_code',
          'bank_account_number',
        ] as (keyof INewWalletQuery)[]);

  const handleSuccess = (response: INewWalletResponse) => {
    openModal(
      <NewWalletMID
        parent_id={response.data.id}
        parent_name={response.data.name}
        refetch={refetch}
        shouldSubmitDefaultSettings={true}
      />,
    );
  };

  const renamedLabels = {
    bank_id: 'Bank',
    provider_id: 'Provider',
    mid_id: 'MID',
    merchant_id: 'Merchant',
    bank_account_number: 'Bank Account Number',
  };

  return (
    <ModalNewEntity
      title='New Wallet'
      submitBtnText='Continue'
      entityKeys={newWalletKeys}
      renamedLabels={renamedLabels}
      useCreateEntityMutation={useCreateWalletMutation}
      onSuccess={handleSuccess}
      otherProps={{ type }}
      keysOrder={[
        'type',
        'provider_id',
        'bank_id',
        'name',
        'wallet_address',
        'bank_code',
        'holder_name',
        'bank_account_number',
        'login_credentials_json',
      ]}
    />
  );
};
